import { classifyToken, normalizeAmpersandEntities } from "./recognize";
import { getTokenDefinition } from "./registry";

const innerOf = (raw: string): string => (raw.startsWith("{{") && raw.endsWith("}}") ? raw.slice(2, -2).trim() : raw);

const fieldOf = (inner: string): string => {
  const dot = inner.indexOf(".");
  return dot >= 0 ? inner.slice(dot + 1) : inner;
};

/**
 * The friendly label to show for a token chip anywhere it renders (rich chips, HTML pills, preview
 * badges): the registry label when known, the field name for a known-namespace custom field, or
 * the raw inner content for an unrecognized token.
 */
export const getTokenLabel = (raw: string): string => {
  const { kind, definitionId } = classifyToken(raw);
  const definition = definitionId ? getTokenDefinition(definitionId) : undefined;
  if (definition) return definition.getLabel();
  const inner = innerOf(raw);
  return kind === "value" ? normalizeAmpersandEntities(fieldOf(inner)) : inner;
};

/** True when the token matches no registry entry or known value namespace (rendered as a fallback). */
export const isUnknownToken = (raw: string): boolean => classifyToken(raw).kind === "unknown";
